import type { ChatMessagesFilterInputType } from "@/types/graphql/partner.generated";
import { toIdList } from "@/partner/shared/utils/filterValues";

/**
 * Общий Filter отдаёт contentIds массивом (он общий для всех списков
 * кабинета), а модерация смотрит на один контент за раз, поэтому берём
 * первый выбранный. search на бэкенде ищет и по тексту сообщения, и по
 * сохранённому имени автора.
 */
export function buildChatMessagesFilter(
  filter: Record<string, unknown>
): ChatMessagesFilterInputType | undefined {
  const result: ChatMessagesFilterInputType = {};

  if (typeof filter.search === "string" && filter.search) {
    result.search = filter.search;
  }

  const contentIds = toIdList(filter.contentIds);
  if (contentIds?.length) {
    result.contentId = contentIds[0];
  }

  return Object.keys(result).length > 0 ? result : undefined;
}
